export default __webpack_public_path__ + "static/fargevekting-4fargekombo-565eab669ec2196d2672649ea592a59b.png";